import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IRequestLinkRecovery, IResponseLinkRecovery } from '@pacifico/interfaces/auth-api.interface';
import { AuthService } from '@pacifico/services/api/auth/auth.service';
import { Router } from '@angular/router';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';
import { IResponse } from '@pacifico/services/api/endpoint-api';
import { IRequestSendEmail, IParameter } from '@pacifico/interfaces/shared-api.interface';
import { SharedApiService } from '@pacifico/services/api/shared/shared-api.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AlertService } from '@pacifico/services/local/alert.service';

@Component({
	selector: 'app-recovery-password',
	templateUrl: './recovery-password.component.html',
	styleUrls: ['./recovery-password.component.scss']
})
export class RecoveryPasswordComponent implements OnInit {
	formGroup!: FormGroup;

	showSucces = false;
	showBirthdateInput = true;
	reqSendEmail!: IRequestSendEmail;
	parameters: IParameter[] = [];

	tokenPassword = '';
	messageErrorPartnerNumber = '';
	messageErrorBirthdate = '';
	placeholder = '';
	customLength = 0;

	typePerson: IParameter[] = [
		{
			name: 'Persona Natural',
			value: 'N'
		},
		{
			name: 'Persona Jurídica',
			value: 'J'
		}
	];

	@Output() hideRecoveryPasswordEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(
		private _authService: AuthService,
		private _sharedService: SharedApiService,
		private _router: Router,
		private _formBuilder: FormBuilder,
		private _datePipe: DatePipe,
		private _alertService: AlertService
	) {
		this._initForm();
	}

	_initForm(): void {
		this.formGroup = this._formBuilder.group({
			personType: [this.typePerson[0], Validators.required],
			partnerNumber: [null, [Validators.required, this._validateCustomLength()]],
			birthdate: [null, Validators.required]
		});
	}

	ngOnInit(): void {
		this.messageErrorBirthdate = 'Debe ingresar su fecha de nacimiento';
		this.initValuesMessages((this.formGroup.controls.personType.value as IParameter).value);
	}

	clickEnviar(): void {
		if (this.formGroup.valid) {
			this._linkRecovery();
			return;
		}
		this.formGroup.markAllAsTouched();
	}

	back2Login(): void {
		this.hideRecoveryPasswordEvent.emit(false);
	}

	goToLogin(): void {
		void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
	}

	private _linkRecovery(): void {
		const reqLinkRecovery: IRequestLinkRecovery = {
			pcip: this.formGroup.controls.partnerNumber.value as string,
			environment: this._getEnviroment(),
			personType: (this.formGroup.controls.personType.value as IParameter).value,
			birthDate: this.birthdate ? this._datePipe.transform(this.birthdate, 'dd/MM/yyyy')! : undefined
		};
		this._authService.linkRecovery(reqLinkRecovery).subscribe((response: IResponse<IResponseLinkRecovery>) => {
			if (response && response.status && response.status.code === '0000') {
				this.tokenPassword = response.data.tokenPassword;
				this.showSucces = true;
			} else {
				this._alertService.showError(response.status.message, 'Error');
				this.formGroup.reset();
			}
		});
	}

	private _sendEmail(personId: string, partnerNumber: string) {
		this.parameters = [];
		this.parameters.push({ name: 'usuario', value: partnerNumber });
		this.parameters.push({ name: 'URLLinkRecovery', value: this._getURL(partnerNumber) });
		this.reqSendEmail = {
			usercode: personId,
			template: 'linkRecovery',
			parameters: this.parameters
		};
		this._sharedService.sendEmail(this.reqSendEmail).subscribe();
	}

	private _getURL(partnerNumber: string) {
		const currentUrl = window.location.href;
		const urlObject = new URL(currentUrl);
		return (
			urlObject.protocol +
			'//' +
			urlObject.hostname +
			':' +
			urlObject.port +
			'/auth/change-password/?token=' +
			this.tokenPassword +
			partnerNumber
		);
	}

	private _getEnviroment(): string {
		const currentURL = window.location.href;
		const urlObject = new URL(currentURL);
		return `${urlObject.protocol}//${urlObject.hostname}`;
	}

	get birthdate(): string {
		return this.formGroup.controls.birthdate.value as string;
	}

	validInputForm(control: string): boolean {
		return this.formGroup.controls[control]?.touched && this.formGroup.controls[control]?.invalid;
	}

	changePersonType(): void {
		const personType = this.formGroup.controls.personType.value as IParameter;
		this.initValuesMessages(personType.value);
		this.formGroup.controls.partnerNumber.reset();
		this.formGroup.controls.birthdate.reset();
	}

	initValuesMessages(personType: string): void {
		switch (personType) {
			case 'N':
				this.customLength = 3;
				this.messageErrorPartnerNumber = `El código de socio o DNI debe ser mayor a ${this.customLength} digitos`;
				this.placeholder = 'DNI o código de socio';
				this.showBirthdateInput = true;
				this.formGroup.controls.birthdate.setValidators(Validators.required);
				break;
			case 'J':
				this.customLength = 3;
				this.messageErrorPartnerNumber = `El código de socio o RUC debe ser de ${this.customLength} digitos`;
				this.placeholder = 'RUC o código de socio';
				this.showBirthdateInput = false;
				this.formGroup.controls.birthdate.setValidators(null);
				break;
			default:
				break;
		}
	}

	private _validateCustomLength(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value as string;
			const validatorError: ValidationErrors = {};
			if (value && value.length < this.customLength) {
				return { customErrorLength: true };
			}
			return validatorError;
		};
	}
}
